import {
  ENABLE_TOOLS_KEY,
  ENABLE_CRM_KEY,
  AUTO_OPEN_LINKEDIN_KEY,
  ENABLE_EVERYWHERE_KEY,
  ENABLE_GMAIL_KEY,
  ENABLE_GCALENDAR_KEY,
} from '../../domain/settings';
import { appStore } from '../appStore';

import { setSettingsItems } from './windowMessaging';

export const defaultUserSettings = [
  { key: ENABLE_TOOLS_KEY, value: true },
  { key: ENABLE_GMAIL_KEY, value: true },
  { key: ENABLE_GCALENDAR_KEY, value: true },
  { key: ENABLE_CRM_KEY, value: true },
  { key: AUTO_OPEN_LINKEDIN_KEY, value: true },
  { key: ENABLE_EVERYWHERE_KEY, value: true },
];

export const setDefaultUserSettings = () => {
  defaultUserSettings.forEach(({ key, value }) => {
    appStore.setSettingsStorageValue({ [key]: value });
    setSettingsItems({ [key]: value });
  });
};
